import { render, staticRenderFns } from "./probationSettings.vue?vue&type=template&id=1ffb0c7f&scoped=true"
import script from "./probationSettings.vue?vue&type=script&lang=js"
export * from "./probationSettings.vue?vue&type=script&lang=js"
import style0 from "./probationSettings.vue?vue&type=style&index=0&id=1ffb0c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb0c7f",
  null
  
)

export default component.exports